import { KnowledgeCategory } from '@/models';
import categories from './categories.json';

export const getCategories = async (): Promise<KnowledgeCategory[]> => {
  // The API URL is updated from App version 1.5
  // This is to include troubleshooting contents inside categories tree
  // Previously, the URL was /api/support/categories/app
  // TODO: Temporary disabled this http request until diagnostics feature is released
  // const categories = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/system/settings/categories`) as IKnowledgeCategory[];
  return categories;
};
